function contains(str: string, val: string): boolean {
  if (!str || !val) return false;
  return str.indexOf(val) !== -1;
}

export default contains;
